module.exports = __webpack_public_path__ + "assets/money-circle-red.ef7f2893.svg";